<template>
    <div class="col-md-12 col-lg-12 mobile_pr_15 bulk-personalization-split">
        <div class="white_box ">
            <!-- Summary Screen (when all items assigned) -->
            <div v-if="showSummary" class="summary-screen">
                <div class="split-header-row">
                    <h1 class="heading1">3. Split Items By Delivery Address</h1>
                </div>
                <!-- Success Message -->
                <div class="alert alert-success mb-4 d-flex align-items-center" role="alert">
                    <img src="/maincss/images/icons/green_check.svg" alt="edit" class="mr-2" style="width: 20px; height: 20px;" /> All {{ totalProductsCount }} Products Are Now Assigned.
                </div>

                <!-- Add Address Option -->
                <div class="d-flex justify-content-end mb-4">
                    <button
                        type="button"
                        class="btn btn-link text_primary_blue p-0 add_address"
                        @click="addNewAddress"
                    >
                    <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_11483_62973)">
                        <path d="M13.4166 6.41664H7.58331V0.583343C7.58331 0.261166 7.32214 0 6.99997 0C6.67779 0 6.41662 0.261166 6.41662 0.583343V6.41667H0.583342C0.261166 6.41664 0 6.67781 0 6.99998C0 7.32216 0.261166 7.58333 0.583342 7.58333H6.41666V13.4167C6.41666 13.7388 6.67782 14 7 14C7.32218 14 7.58334 13.7388 7.58334 13.4167V7.58333H13.4167C13.7388 7.58333 14 7.32216 14 6.99998C14 6.67781 13.7388 6.41664 13.4166 6.41664Z" fill="#1D6CB5"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_11483_62973">
                        <rect width="14" height="14" fill="white"/>
                        </clipPath>
                        </defs>
                        </svg>Add Address
                    </button>
                </div>

                <!-- Addresses List with Product Counts -->
                <div class="addresses-summary-list">
                    <div 
                        v-for="(address, addrIndex) in orderedSplitAddresses" 
                        :key="address.id || address._originalIndex || addrIndex"
                        class="address-summary-item"
                    >
                        <div class="address-summary-row d-flex justify-content-between align-items-center">
                            <div class="address-summary-left">
                                <span class="address-summary-label">Address {{ addrIndex + 1 }}:</span>
                                <span class="address-summary-details">
                                    {{ getAddressDisplayName(address) }}{{ address.company_name ? ', ' + address.company_name : '' }}{{ address.fullname ? ', ' + address.fullname : '' }}{{ address.address_line1 ? ', ' + address.address_line1 : '' }}{{ address.city ? ', ' + address.city : '' }}{{ address.state ? ', ' + address.state : '' }}{{ address.zip ? ' ' + address.zip : '' }}
                                </span>
                            </div>
                            <div class="address-summary-right d-flex align-items-center">
                                <span v-if="address.is_default" class="badge-primary">Default Address</span>
                                <span class="address-products-count">{{ getAssignedProductsCount(address, address._originalIndex) }} Products Added</span>
                                <button
                                    type="button"
                                    class="btn-add-product"
                                    @click="viewProductsForAddress(address._originalIndex)"
                                >
                                    View Product
                                </button>
                                <button
                                    type="button"
                                    class="btn-edit-address"
                                    aria-label="Edit address"
                                    @click="editAddressAssignment(address._originalIndex)"
                                >
                                    <img src="/maincss/images/icons/new-edit.svg" alt="edit" class="mr-1" style="width: 14px; height: 14px;" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Disclaimer -->
                
            </div>

            <!-- Main Assignment Screen -->
            <div v-else>
                <!-- Header row: title left, Total/Selected right -->
                <div class="split-header-row">
                    <h1 class="heading1">3. Split Items By Delivery Address</h1>
                   
                </div>
                <div class="products-summary_block">
                    <div class="total_product">
                        <p>Total {{ totalProductsCount }} Products</p>
                    </div>
                    <div class="selected_product">
                        <p>Selected {{ selectedProductsCount }} Products</p>
                    </div>
                </div>
            <!-- Bulk Split Table -->
            <div class="bulk-split-table-section" v-if="products.length > 0 && splitAddresses.length > 0">
                <div class="table-responsive">
                    <table class="table table-bordered bulk-split-table">
                        <thead>
                            <!-- Product Headers Row -->
                            <tr>
                                <th class="address-col sticky-col"></th>
                                <th 
                                    v-for="(product, productIndex) in products" 
                                    :key="productIndex"
                                    class="product-col"
                                >
                                    <div class="product-header">
                                        <div class="product-image-wrapper">
                                            <DisplayProductImage
                                                :whateverActivatesThisLink="false"
                                                :product="product.main_new_product"
                                                :designImage="product.design_image"
                                                :colorProductImage="product.product_image"
                                                :color="product.color_id"
                                                :classValue="'product-thumb'"
                                            />
                                        </div>
                                        <div class="product-info">
                                            <div class="design-name">{{ getDesignNameLabel(product) }}</div>
                                            <div class="product-name">
                                                {{ product.product_number }}
                                                <strong>{{ product.color_name }}</strong>
                                                -
                                                <strong>{{ product.size_name }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            <!-- Quantity Status Row -->
                            <tr>
                                <th class="sticky-col">Qty</th>
                                <th 
                                    v-for="(product, productIndex) in products" 
                                    :key="productIndex"
                                    class="quantity-status-header"
                                >
                                    <div 
                                        class="quantity-status"
                                        :class="{
                                            'status-assigned': getUnassignedQuantity(product) === 0,
                                            'status-unassigned': getUnassignedQuantity(product) > 0
                                        }"
                                    >
                                        <span v-if="getUnassignedQuantity(product) === 0" class="assigned-text">
                                            {{ getAssignedQuantity(product) }}/{{ getTotalQuantity(product) }}
                                        </span>
                                        <template v-else>
                                            <span class="unassigned-number">{{ getUnassignedQuantity(product) }}</span>
                                            <span class="unassigned-text"> Unassigned / </span>
                                            <span class="total-text">{{ getTotalQuantity(product) }} Total</span>
                                        </template>
                                    </div>
                                </th>
                            </tr>
                            <!-- Qty Headers Row -->
                            <tr class="qty-headers-row">
                                <th class="sticky-col qty-label-cell">Address</th>
                                <th 
                                    v-for="(product, productIndex) in products" 
                                    :key="productIndex"
                                    class="qty-header"
                                >
                                    Qty
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr 
                                v-for="(address, addressIndex) in orderedSplitAddresses" 
                                :key="address.id || address._originalIndex || addressIndex"
                            >
                                <!-- Address Name -->
                                <td class="sticky-col address-cell qty-cell">
                                    <div class="address-line address-number">{{ addressIndex + 1 }}. <strong>{{ getAddressDisplayName(address) }}.</strong></div>
                                    <div class="address-line address-company"></div>
                                    <div class="address-line address-recipient">
                                        <span class="address-recipient-name">{{ address.fullname }}</span>
                                        <span v-if="address.is_default" class="default-address-badge">(Default Address)</span>
                                    </div>
                                </td>
                                
                                <!-- Quantity Inputs for Each Product -->
                                <td 
                                    v-for="(product, productIndex) in products" 
                                    :key="productIndex"
                                    class="qty-cell"
                                >
                                    <div class="quantity-control">
                                        <button
                                            type="button"
                                            class="qty-btn qty-minus"
                                            aria-label="Decrease quantity"
                                            @click="decrementQty(address._originalIndex, productIndex)"
                                            :disabled="getQtyForCell(address._originalIndex, productIndex) <= 0"
                                        >
                                            <span class="qty-btn-icon" aria-hidden="true">−</span>
                                        </button>
                                        <input
                                            type="number"
                                            class="qty-input"
                                            :value="getQtyForCell(address._originalIndex, productIndex)"
                                            @input="updateQty(address._originalIndex, productIndex, $event)"
                                            :max="getAvailableQtyForProduct(address._originalIndex, productIndex)"
                                            min="0"
                                        />
                                        <button
                                            type="button"
                                            class="qty-btn qty-plus"
                                            aria-label="Increase quantity"
                                            @click="incrementQty(address._originalIndex, productIndex)"
                                            :disabled="getQtyForCell(address._originalIndex, productIndex) >= getAvailableQtyForProduct(address._originalIndex, productIndex)"
                                        >
                                            <span class="qty-btn-icon" aria-hidden="true">+</span>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

                <!-- No Products Message -->
                <div v-else class="alert alert-info">
                    <p>No products available for splitting.</p>
                </div>

                <!-- Disclaimer -->
               
            </div>
        </div>
        <div class="disclaimer">
            <p class="text-muted small">
                Disclaimer: Final Kitting Costs May Be More Or Less Than Shown, This Amount Should Be Considered An Estimate. Shipping Costs Can Vary Significantly Based On Location.
            </p>
        </div>
    </div>
</template>

<script>
import DisplayProductImage from "@/components/DisplayProductImageNew.vue";
import ApiService from "@/common/api.service";

export default {
    name: "BulkPersonalizationSplit",
    components: {
        DisplayProductImage
    },
    data() {
        return {
            products: [], // Grouped products by design, color, size
            quantityAssignments: {}, // { addressIndex: { productIndex: quantity } }
            showSummary: false, // Show summary screen when all items assigned
            designNamesMap: {} // saved_design_id -> name from save_design table
        };
    },
    computed: {
        isSplitShipment() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.isSplitShipment;
        },
        splitAddresses() {
            const splitShipmentModule = this.$store.state.splitShipment;
            const addresses = splitShipmentModule && splitShipmentModule.splitAddresses;
            return Array.isArray(addresses) ? addresses : [];
        },
        orderedSplitAddresses() {
            const addresses = Array.isArray(this.splitAddresses) ? this.splitAddresses : [];
            return addresses
                .map((address, index) => ({ ...address, _originalIndex: index }));
        },
        totalProductsCount() {
            // Count total items across all products
            return this.products.reduce((total, product) => {
                return total + this.getTotalQuantity(product);
            }, 0);
        },
        selectedProductsCount() {
            // Count assigned items
            let total = 0;
            Object.keys(this.quantityAssignments).forEach(addressIndex => {
                Object.keys(this.quantityAssignments[addressIndex]).forEach(productIndex => {
                    total += this.quantityAssignments[addressIndex][productIndex] || 0;
                });
            });
            return total;
        }
    },
    mounted() {
        this.loadCartItems();
    },
    methods: {
        loadCartItems() {
            // Get cart items from CartSummary component
            const cartSummaryRef = this.$parent.$refs.cartSummaryRef;
            if (!cartSummaryRef || !cartSummaryRef.cart_items) {
                console.warn("[BulkPersonalizationSplit] No cart items available");
                setTimeout(() => {
                    this.loadCartItems();
                }, 500);
                return;
            }

            const cartItems = cartSummaryRef.cart_items;
            const groupedProducts = [];

            // Group products by design, color, and size
            cartItems.forEach((cartItem) => {
                // Handle main CartChildItems
                if (cartItem.CartChildItems && cartItem.CartChildItems.length > 0) {
                    cartItem.CartChildItems.forEach((childItem) => {
                        this.addProductToGroup(childItem, cartItem, groupedProducts);
                    });
                }

                // Handle subItems if they exist
                if (cartItem.subItems && cartItem.subItems.length > 0) {
                    cartItem.subItems.forEach((subItem) => {
                        if (subItem.CartChildItems && subItem.CartChildItems.length > 0) {
                            subItem.CartChildItems.forEach((childItem) => {
                                this.addProductToGroup(childItem, subItem, groupedProducts);
                            });
                        }
                    });
                }
            });

            this.products = groupedProducts;
            this.initializeQuantityAssignments();
            this.restoreQuantityAssignmentsFromVuex();
            this.fetchDesignNames();
        },
        fetchDesignNames() {
            const ids = [];
            this.products.forEach((p) => {
                if (p.saved_design_id && ids.indexOf(p.saved_design_id) === -1) {
                    ids.push(p.saved_design_id);
                }
            });
            if (ids.length === 0) return;
            const map = {};
            Promise.all(
                ids.map((id) =>
                    ApiService.get("/get-single-design/" + id)
                        .then(({ data }) => {
                            if (data && data.design && data.design.name) {
                                map[id] = data.design.name;
                            }
                        })
                        .catch(() => {})
                )
            ).then(() => {
                this.designNamesMap = Object.assign({}, this.designNamesMap, map);
            });
        },
        restoreQuantityAssignmentsFromVuex() {
            const saved = (this.$store.state.splitShipment && this.$store.state.splitShipment.productAssignments) || {};
            const keys = Object.keys(saved);
            if (keys.length === 0) return;
            keys.forEach((key) => {
                const entry = saved[key];
                if (!entry || entry.addressIndex == null) return;
                const addressIndex = entry.addressIndex;
                const productInfo = entry.product;
                if (!productInfo) return;
                const productIndex = this.products.findIndex(
                    p => p.product_number === productInfo.product_number &&
                          String(p.color_id) === String(productInfo.color_id) &&
                          p.size_name === productInfo.size_name
                );
                if (productIndex === -1) return;
                if (!this.quantityAssignments[addressIndex]) {
                    this.$set(this.quantityAssignments, addressIndex, {});
                }
                const current = this.quantityAssignments[addressIndex][productIndex] || 0;
                this.$set(this.quantityAssignments[addressIndex], productIndex, current + (entry.quantity || 1));
            });
        },
        addProductToGroup(childItem, parentItem, groupedProducts) {
            const quantity = parseInt(childItem.quantity || 0);
            if (quantity <= 0) return;

            const mainProduct = childItem.main_new_sub_product;
            const productNumber = (parentItem.main_new_product && parentItem.main_new_product.product_number) || 
                                  parentItem.product_number || 'N/A';
            const productName = (parentItem.main_new_product && parentItem.main_new_product.name) || 
                                parentItem.name || 'N/A';
            
            // Get color and size
            const colorObj = mainProduct && mainProduct.Color;
            const colorName = (colorObj && colorObj.name) || (colorObj && colorObj.color_name) || 'N/A';
            const colorId = childItem.color_id || (colorObj && colorObj.id);
            
            const sizeObj = mainProduct && mainProduct.Size;
            let sizeName = 'N/A';
            if (sizeObj) {
                if (sizeObj.size_name) {
                    sizeName = sizeObj.size_name;
                } else if (sizeObj.size) {
                    const sizeParts = sizeObj.size.trim().split(/\s+/);
                    sizeName = sizeParts[sizeParts.length - 1];
                }
            }

            // Check if product already exists in group
            const existingProduct = groupedProducts.find(p => 
                p.product_number === productNumber &&
                p.color_id === colorId &&
                p.size_name === sizeName
            );

            if (existingProduct) {
                existingProduct.totalQuantity += quantity;
                existingProduct.unassignedQuantity += quantity;
                // Add this childItem to the list of childItems for this product group
                if (!existingProduct.childItems) {
                    existingProduct.childItems = [];
                }
                // Add multiple entries if quantity > 1 (one per item)
                for (let i = 0; i < quantity; i++) {
                    existingProduct.childItems.push({
                        cartItemId: parentItem.id,
                        childItemId: childItem.id,
                        childItem: childItem,
                        parentItem: parentItem
                    });
                }
            } else {
                // Initialize childItems array
                const childItems = [];
                // Add multiple entries if quantity > 1 (one per item)
                for (let i = 0; i < quantity; i++) {
                    childItems.push({
                        cartItemId: parentItem.id,
                        childItemId: childItem.id,
                        childItem: childItem,
                        parentItem: parentItem
                    });
                }
                
                groupedProducts.push({
                    product_number: productNumber,
                    product_name: productName,
                    color_id: colorId,
                    color_name: colorName,
                    size_name: sizeName,
                    totalQuantity: quantity,
                    unassignedQuantity: quantity,
                    main_new_product: parentItem.main_new_product,
                    design_image: parentItem.design_image,
                    product_image: parentItem.product_image,
                    cartItemId: parentItem.id, // Keep for backward compatibility
                    childItemId: childItem.id, // Keep for backward compatibility
                    childItems: childItems, // Store all childItems for this product group
                    saved_design_id: parentItem.saved_design_id || null
                });
            }
        },
        initializeQuantityAssignments() {
            // Initialize quantity assignments for all addresses and products
            const assignments = {};
            this.splitAddresses.forEach((address, addressIndex) => {
                assignments[addressIndex] = {};
                this.products.forEach((product, productIndex) => {
                    assignments[addressIndex][productIndex] = 0;
                });
            });
            this.quantityAssignments = assignments;
        },
        getDesignNameLabel(product) {
            if (product.saved_design_id && this.designNamesMap[product.saved_design_id]) {
                return this.designNamesMap[product.saved_design_id];
            }
            return 'Design Name';
        },
        getTotalQuantity(product) {
            return product.totalQuantity || 0;
        },
        getUnassignedQuantity(product) {
            const productIndex = this.products.findIndex(p => 
                p.product_number === product.product_number &&
                p.color_id === product.color_id &&
                p.size_name === product.size_name
            );
            
            if (productIndex === -1) return product.totalQuantity || 0;
            
            const totalAssigned = this.splitAddresses.reduce((sum, address, addressIndex) => {
                return sum + (this.quantityAssignments[addressIndex] && this.quantityAssignments[addressIndex][productIndex] || 0);
            }, 0);
            
            return (product.totalQuantity || 0) - totalAssigned;
        },
        getAssignedQuantity(product) {
            const productIndex = this.products.findIndex(p => 
                p.product_number === product.product_number &&
                p.color_id === product.color_id &&
                p.size_name === product.size_name
            );
            
            if (productIndex === -1) return 0;
            
            return this.splitAddresses.reduce((sum, address, addressIndex) => {
                return sum + (this.quantityAssignments[addressIndex] && this.quantityAssignments[addressIndex][productIndex] || 0);
            }, 0);
        },
        getQtyForCell(addressIndex, productIndex) {
            return this.quantityAssignments[addressIndex] && this.quantityAssignments[addressIndex][productIndex] || 0;
        },
        getTotalQtyForAddress(addressIndex) {
            if (!this.quantityAssignments[addressIndex]) return 0;
            return Object.values(this.quantityAssignments[addressIndex]).reduce((sum, qty) => sum + (qty || 0), 0);
        },
        getMaxQtyForProduct(productIndex) {
            const product = this.products[productIndex];
            if (!product) return 0;
            // Max quantity is the total quantity for this product
            return product.totalQuantity || 0;
        },
        getAvailableQtyForProduct(addressIndex, productIndex) {
            const product = this.products[productIndex];
            if (!product) return 0;
            
            // Calculate how many are already assigned to other addresses
            const assignedToOthers = this.splitAddresses.reduce((sum, addr, addrIdx) => {
                if (addrIdx !== addressIndex) {
                    return sum + (this.quantityAssignments[addrIdx] && this.quantityAssignments[addrIdx][productIndex] || 0);
                }
                return sum;
            }, 0);
            
            // Available = Total - Assigned to others
            return (product.totalQuantity || 0) - assignedToOthers;
        },
        getCurrentAddressIndex() {
            // For bulk split, we don't have a current address index
            return 0;
        },
        incrementQty(addressIndex, productIndex) {
            const currentQty = this.getQtyForCell(addressIndex, productIndex);
            const availableQty = this.getAvailableQtyForProduct(addressIndex, productIndex);
            
            if (currentQty < availableQty) {
                if (!this.quantityAssignments[addressIndex]) {
                    this.$set(this.quantityAssignments, addressIndex, {});
                }
                this.$set(this.quantityAssignments[addressIndex], productIndex, currentQty + 1);
                this.updateProductAssignments();
            }
        },
        decrementQty(addressIndex, productIndex) {
            const currentQty = this.getQtyForCell(addressIndex, productIndex);
            if (currentQty > 0) {
                if (!this.quantityAssignments[addressIndex]) {
                    this.$set(this.quantityAssignments, addressIndex, {});
                }
                this.$set(this.quantityAssignments[addressIndex], productIndex, currentQty - 1);
                this.updateProductAssignments();
            }
        },
        updateQty(addressIndex, productIndex, event) {
            const value = parseInt(event.target.value) || 0;
            const availableQty = this.getAvailableQtyForProduct(addressIndex, productIndex);
            const finalValue = Math.max(0, Math.min(value, availableQty));
            
            if (!this.quantityAssignments[addressIndex]) {
                this.$set(this.quantityAssignments, addressIndex, {});
            }
            this.$set(this.quantityAssignments[addressIndex], productIndex, finalValue);
            this.updateProductAssignments();
        },
        getAddressDisplayName(address) {
            if (address.company_name) return address.company_name;
            if (address.address_title) return address.address_title;
            return `Address`;
        },
        updateProductAssignments() {
            // Convert quantity assignments to product assignments format for Vuex
            const assignments = {};
            let totalAssignments = 0;
            
            // Track which childItem index we're at for each product group
            const childItemIndexTracker = {};
            
            // First, initialize trackers for all products
            this.products.forEach((product, productIndex) => {
                childItemIndexTracker[productIndex] = 0;
            });
            
            // Process each address in order
            this.splitAddresses.forEach((address, addressIndex) => {
                this.products.forEach((product, productIndex) => {
                    const qty = this.getQtyForCell(addressIndex, productIndex);
                    if (qty > 0) {
                        // Get the list of childItems for this product group
                        const childItems = product.childItems || [];
                        
                        if (childItems.length === 0) {
                            // Fallback: if no childItems array, use the single cartItemId/childItemId
                            // This shouldn't happen if addProductToGroup is working correctly
                            console.warn(`[BulkPersonalizationSplit] Product ${productIndex} has no childItems array, using fallback`);
                            for (let i = 0; i < qty; i++) {
                                const uniqueKey = `bulk_${product.cartItemId}_${product.childItemId}_${productIndex}_${addressIndex}_${i}_${Date.now()}_${Math.random()}`;
                                const cartItemId = product.cartItemId || product.id;
                                const childItemId = product.childItemId || null;
                                assignments[uniqueKey] = {
                                    addressIndex: addressIndex,
                                    addressId: address.id || address.address_id || null,
                                    selected: true,
                                    product: product,
                                    quantity: 1,
                                    item: { cartItemId, childItemId, quantity: 1, unit_price: product.unit_price || 0 }
                                };
                                totalAssignments++;
                            }
                        } else {
                            // Get current index for this product
                            let currentIndex = childItemIndexTracker[productIndex];
                            
                            // Assign qty number of childItems to this address
                            for (let i = 0; i < qty; i++) {
                                if (currentIndex < childItems.length) {
                                    const childItemData = childItems[currentIndex];
                                    const uniqueKey = `bulk_${childItemData.cartItemId}_${childItemData.childItemId}_${productIndex}_${addressIndex}_${i}_${Date.now()}_${Math.random()}`;
                                    const cartItemId = childItemData.cartItemId || product.cartItemId;
                                    const childItemId = childItemData.childItemId || product.childItemId || null;
                                    const qtyVal = 1;
                                    assignments[uniqueKey] = {
                                        addressIndex: addressIndex,
                                        addressId: address.id || address.address_id || null,
                                        selected: true,
                                        product: {
                                            ...product,
                                            cartItemId: childItemData.cartItemId,
                                            childItemId: childItemData.childItemId
                                        },
                                        quantity: qtyVal,
                                        item: { cartItemId, childItemId, quantity: qtyVal, unit_price: (childItemData.unit_price != null ? childItemData.unit_price : product.unit_price) || 0 }
                                    };
                                    totalAssignments++;
                                    currentIndex++;
                                } else {
                                    // If we run out of childItems, log a warning
                                    console.warn(`[BulkPersonalizationSplit] Not enough childItems for product ${productIndex} (${product.product_number}), requested ${qty} but only ${childItems.length} available. Current index: ${currentIndex}`);
                                    break;
                                }
                            }
                            
                            // Update tracker for next address
                            childItemIndexTracker[productIndex] = currentIndex;
                        }
                    }
                });
            });
            
            
            // Save to Vuex
            this.$store.commit('splitShipment/setProductAssignments', assignments);
            
            // Verify what was saved
            const savedAssignments = this.$store.state.splitShipment && this.$store.state.splitShipment.productAssignments || {};
            if (Object.keys(savedAssignments).length > 0) {
                const firstKey = Object.keys(savedAssignments)[0];
                const a = savedAssignments[firstKey];
            }
        },
        goBackToAddresses() {
            this.$emit('go-back-to-addresses');
        },
        proceedToNext() {
            // Check if all items are assigned
            const totalUnassigned = this.products.reduce((sum, product) => {
                return sum + this.getUnassignedQuantity(product);
            }, 0);
            
            if (totalUnassigned > 0) {
                this.$toast.warning(`${totalUnassigned} items still need to be assigned. Please assign all items before proceeding.`, {
                    position: "top-right"
                });
                return;
            }
            
            // All items assigned, show summary screen
            this.updateProductAssignments();
            this.showSummary = true;
            this.$toast.success("All items have been assigned to addresses", {
                position: "top-right"
            });
        },
        allItemsAssigned() {
            // Check if all items are assigned
            const totalUnassigned = this.products.reduce((sum, product) => {
                return sum + this.getUnassignedQuantity(product);
            }, 0);
            return totalUnassigned === 0;
        },
        getAssignedProductsCount(address, addressIndex) {
            // Count total products assigned to this address
            if (!this.quantityAssignments[addressIndex]) return 0;
            return Object.values(this.quantityAssignments[addressIndex]).reduce((sum, qty) => sum + (qty || 0), 0);
        },
        viewProductsForAddress(addressIndex) {
            // Go back to assignment screen for this address
            this.showSummary = false;
        },
        editAddressAssignment(addressIndex) {
            // Go back to assignment screen for this address
            this.showSummary = false;
        },
        addNewAddress() {
            // Go back to addresses step
            this.$emit('go-back-to-addresses');
        },
        // Back from footer; summary -> list, else let caller go to addresses
        goToPreviousAddress() {
            if (this.showSummary) {
                this.showSummary = false;
                return true;
            }
            return false;
        }
    }
};
</script>

<style scoped>
.bulk-personalization-split {
    padding: 20px 0;
    margin-bottom: 80px;
}
.bulk-personalization-split .white_box {
    padding: 24px 32px !important;
}
/* Header row: title left, Total/Selected right (match SplitItemsByAddress) */
.split-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0px;
    flex-wrap: wrap;
    gap: 12px;
}
.bulk-personalization-split .split-header-row h1 { 
    margin-bottom: 24px !important;
}
 .products-summary_block {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding: 0;
    margin-bottom: 0;
}
.products-summary_block p {
    margin-bottom: 0;
    color: #121212;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
}
 .products-summary_block .total_product {
    padding-right: 16px;
    border-right: 1px solid #E0E0E0;
}

.bulk-personalization-split .heading1 {
    color: #121212;
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 4px;
}

.bulk-split-table-section {
    overflow-x: auto;
    margin-top: 20px;
    border: 1px solid #E0E0E0;
    border-radius: 2px;
    /* Show vertical scroll after ~8 rows */
    max-height: 60vh;
    overflow-y: auto;
}

.bulk-split-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 800px;
}

/* Header cells: white background, light grey borders (screenshot) */
.bulk-split-table thead th {
    background-color: #ffffff;
    font-weight: 800;
    padding: 8px;
    text-align: center;
    border: 1px solid #E0E0E0;
    vertical-align: middle;
    position: relative;
    font-size: 12px;
    line-height: 12px;
    color: #121212;
    min-width: 190px;
}
.bulk-split-table thead th.address-col{
    min-width: 254px;
}
.bulk-split-table thead th:first-child {
    text-align: left;
}
/* .bulk-split-table thead th.sticky-col {
    background-color: #ffffff;
} */

.qty-label-cell {
    font-weight: 400;
    color: #000000;
}

.sticky-col {
    position: sticky !important;
    left: -1px;
    background-color: #fff;
    z-index: 10;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);
    border-right: 1px solid #BEBEBE4D !important;
}

.address-col {
    min-width: 220px;
    text-align: left;
    vertical-align: top;
}
.bulk-split-table .qty-headers-row th{
    background-color: #F4F4F4;
}
.bulk-split-table thead tr:first-child th {
    border-bottom: 2px solid #E0E0E0;
}

.product-col {
    min-width: 140px;
    text-align: center;
    background-color: #ffffff !important;
    border: 1px solid #E0E0E0;
}

.product-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 8px;
    min-width: 120px;
}

/* Product image: 40px x 40px (screenshot) */
.product-image-wrapper {
    margin-bottom: 8px;
    width: 100px;
    height: 100px;
    min-width: 100px;
    min-height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    overflow: hidden;
}

.product-image-wrapper img,
.product-image-wrapper .product-thumb,
.product-image-wrapper :deep(img) {
    width: 100px !important;
    height: 100px !important;
    max-width: 100px !important;
    max-height: 100px !important;
    min-width: 100px !important;
    min-height: 100px !important;
    object-fit: contain;
}

.product-info {
    text-align: center;
    width: 100%;
}

/* Design Name: centered, regular weight, black (screenshot) */
.design-name {
    font-size: 16px;
    color: #121212;
    font-weight: 500;
    margin-bottom: 4px;
    line-height: 18px;
}

/* Product model/color/size: product # regular; color & size emphasized */
.product-name {
    font-size: 16px;
    font-weight: 600;
    color: #121212;
    margin-bottom: 0;
    line-height: 18px;
}

.product-name strong {
    font-weight: 600;
}

.product-quantity {
    font-size: 12px;
    font-weight: 600;
}

.product-quantity.text-success {
    color: #28a745 !important;
}

.product-quantity.text-danger {
    color: #dc3545 !important;
}

.quantity-status-header {
    padding: 8px 4px;
    background-color: #ffffff;
    border: 1px solid #E0E0E0;
}

.quantity-status {
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    padding: 0px 8px;
}

.quantity-status.status-assigned {
    color: #00A053;
}

.quantity-status.status-unassigned {
    background-color: transparent;
}

.assigned-text {
    color: #00A053;
    font-weight: 700;
}

/* Unassigned: number + "Unassigned" in red; " / Y Total" in dark grey (screenshot) */
.quantity-status .unassigned-number,
.quantity-status .unassigned-text {
    color: #FF3B30;
    font-weight: 600;
}

.quantity-status .total-text {
    color: #374151;
    font-weight: 500;
}

.qty-header {
    font-size: 12px;
    font-weight: 400;
    padding: 8px 4px;
    color: #000000;
    background-color: #ffffff;
}

.bulk-split-table tbody td {
    padding: 12px 8px;
    border: 1px solid #E0E0E0;
    text-align: center;
    vertical-align: middle;
    background-color: #fff;
    font-size: 12px;
    line-height: 12px;
    color: #121212;
}

.address-cell {
    text-align: left;
    min-width: 220px;
    padding: 12px !important;
    vertical-align: top !important;
}

.address-cell .address-line {
    display: block;
    margin-bottom: 0px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    color: #121212;
}
.address-cell .address-line .address-recipient-name{
    color: #414141;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
}
.address-cell .address-line:last-child {
    margin-bottom: 0;
}

/* (Default Address) badge: grey rounded rectangle, white text (screenshot) */
.address-cell .default-address-badge {
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
    color: #929292;
    background-color: transparent;
    padding: 0px;
    margin-left: 6px;
    vertical-align: middle;
}

.qty-cell,
.total-qty-cell {
    text-align: left !important;
}

.bulk-split-table tbody td.qty-cell:not(.address-cell) {
    text-align: center !important;
    vertical-align: middle;
    border-color: #e0e0e0;
}

/* Quantity control: minimal row — grey − | dark qty | grey + (no box) */
.bulk-personalization-split .quantity-control {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    max-width: 132px;
    margin: 0 auto;
    padding: 0;
    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
}

.bulk-personalization-split .quantity-control .qty-btn {
    flex-shrink: 0;
    width: auto;
    min-width: 24px;
    height: auto;
    padding: 2px 4px;
    margin: 0;
    border: none;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #929292;
    transition: color 0.15s ease;
}

.bulk-personalization-split .quantity-control .qty-btn-icon {
    display: block;
    font-size: 20px;
    line-height: 1;
    font-weight: 300;
    font-family: inherit;
}

.bulk-personalization-split .quantity-control .qty-btn.qty-minus .qty-btn-icon {
    font-size: 18px;
    transform: translateY(-1px);
}

.bulk-personalization-split .quantity-control .qty-btn:hover:not(:disabled) {
    background: transparent;
    color: #7a7a7a;
}

.bulk-personalization-split .quantity-control .qty-btn:focus {
    outline: none;
}

.bulk-personalization-split .quantity-control .qty-btn:focus-visible {
    outline: 2px solid #1d6cb5;
    outline-offset: 2px;
}

.bulk-personalization-split .quantity-control .qty-btn:disabled {
    color: #d1d5db;
    cursor: not-allowed;
}

.bulk-personalization-split .quantity-control input.qty-input,
.shipping_payment_detail .shipping_fl_left input.qty-input {
    flex: 1 1 auto;
    min-width: 28px;
    max-width: 56px;
    width: 100%;
    height: auto;
    min-height: 24px;
    padding: 2px 4px;
    margin: 0;
    border: none;
    border-radius: 0;
    text-align: center;
    font-size: 14px !important;
    font-weight: 400;
    line-height: 1.2;
    color: #121212;
    background: transparent;
    box-shadow: none;
}

.bulk-personalization-split .quantity-control .qty-input:focus {
    outline: none;
    box-shadow: none;
}

.bulk-personalization-split .quantity-control .qty-input:focus-visible {
    outline: 2px solid #1d6cb5;
    outline-offset: 1px;
    border-radius: 2px;
}

.bulk-personalization-split .quantity-control .qty-input::-webkit-outer-spin-button,
.bulk-personalization-split .quantity-control .qty-input::-webkit-inner-spin-button,
.shipping_payment_detail .shipping_fl_left input.qty-input::-webkit-outer-spin-button,
.shipping_payment_detail .shipping_fl_left input.qty-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
}

.bulk-personalization-split .quantity-control .qty-input[type="number"],
.shipping_payment_detail .shipping_fl_left input.qty-input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
}

.disclaimer {
    font-size: 12px;
    line-height: 12px;
    color: #414141;
    font-style: italic;
    margin-top: 16px;
    position: absolute;
    bottom: -10px;
}
.disclaimer p{
    font-size: 12px;
    line-height: 12px;
    color: #414141;
    font-style: italic;
    margin: 0px;
}



/* Summary Screen Styles (match SplitItemsByAddress) */
.summary-screen {
    padding: 20px 0;
}

.addresses-summary-list {
    margin-top: 8px;
    border-top: 1px solid #E0E0E0;
    border-bottom: 1px solid #E0E0E0;
}

.address-summary-item {
    padding: 16px 0 12px 0;
    border-bottom: 1px solid #E0E0E0;
    background-color: #fff;
}

.address-summary-item:last-child {
    border-bottom: none;
}

.address-summary-row {
    flex-wrap: wrap;
    gap: 12px;
}

.address-summary-left {
    flex: 1;
    min-width: 0;
}

.address-summary-label {
    font-weight: 700;
    color: #333;
    font-size: 14px;
    margin-right: 4px;
}

.address-summary-details {
    color: #333;
    font-size: 14px;
    font-weight: 400;
}

.address-summary-right {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
}
.bulk-split-table .address-cell .address-recipient{
    display: flex;
    justify-content: space-between;
    padding-left: 10px;
}
.bulk-personalization-split .badge-primary {
    color: #1D6CB5;
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    background-color: #1D6CB51A;
    padding: 4px;
    border-radius: 4px;
}

.address-products-count {
    font-size: 14px;
    color: #666;
    font-weight: 400;
}

.btn-add-product {
    padding: 6px 14px;
    font-size: 14px;
    font-weight: 500;
    color: #1D6CB5;
    background-color: #fff;
    border: 1px solid #1D6CB5;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
}

.btn-add-product:hover {
    background-color: rgba(29, 108, 181, 0.08);
}
.alert-success {
    background-color: #00A05314;
    border-color: #00A05314;
    color: #00A053;
    padding: 13px 16px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
}
.btn-edit-address {
    padding: 6px;
    background: transparent;
    border: none;
    color: #333;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.btn-edit-address:hover {
    color: #1D6CB5;
}

.text_primary_blue {
    color: #1d6cb5;
}

.text_primary_blue:hover {
    color: #155a8a;
    text-decoration: none;
}
.add_address{
    letter-spacing: 0px;
    font-size: 14px;
    font-weight: 700;
    color: #1D6CB5;
}

@media (max-width: 991px) {
    .bulk-personalization-split {
        padding: 12px 0;
        margin-bottom: 56px;
    }

    .bulk-personalization-split .white_box {
        padding: 20px !important;
    }

    .split-header-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .bulk-personalization-split .split-header-row h1 {
        margin-bottom: 8px !important;
    }

    .products-summary_block {
        justify-content: flex-start;
        flex-wrap: wrap;
        margin-bottom: 8px;
    }

    .bulk-split-table-section {
        margin-top: 16px;
        max-height: 58vh;
    }

    .bulk-split-table {
        min-width: 700px;
    }

    .bulk-split-table thead th {
        min-width: 160px;
    }

    .bulk-split-table thead th.address-col,
    .address-cell {
        min-width: 200px;
    }

    .product-image-wrapper,
    .product-image-wrapper img,
    .product-image-wrapper .product-thumb,
    .product-image-wrapper :deep(img) {
        width: 72px !important;
        height: 72px !important;
        max-width: 72px !important;
        max-height: 72px !important;
        min-width: 72px !important;
        min-height: 72px !important;
    }

    .design-name,
    .product-name {
        font-size: 14px;
        line-height: 16px;
    }

    .address-summary-right {
        width: 100%;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 10px;
    }

    .btn-add-product {
        padding: 6px 12px;
        font-size: 13px;
    }

    .disclaimer {
        position: static;
        margin-top: 16px;
    }
}

@media (max-width: 767px) {
    .bulk-personalization-split .white_box {
        padding: 16px !important;
    }

    .bulk-personalization-split .heading1 {
        font-size: 18px;
        line-height: 22px;
    }

    .products-summary_block p {
        font-size: 13px;
        line-height: 16px;
    }

    .products-summary_block .total_product {
        padding-right: 10px;
    }

    .bulk-split-table {
        min-width: 620px;
    }

    .bulk-split-table thead th {
        min-width: 138px;
        font-size: 11px;
        line-height: 14px;
        padding: 8px 6px;
    }

    .bulk-split-table thead th.address-col,
    .address-cell {
        min-width: 180px;
    }

    .bulk-split-table tbody td {
        padding: 10px 6px;
    }

    .bulk-personalization-split .quantity-control {
        max-width: 110px;
        gap: 2px;
    }

    .bulk-personalization-split .quantity-control .qty-btn-icon {
        font-size: 18px;
    }

    .bulk-personalization-split .quantity-control input.qty-input,
    .shipping_payment_detail .shipping_fl_left input.qty-input {
        max-width: 44px;
        font-size: 13px !important;
    }

    .address-summary-item {
        padding: 12px 0 10px 0;
    }

    .address-summary-label,
    .address-summary-details,
    .address-products-count {
        font-size: 13px;
    }

    .d-flex.justify-content-end.mb-4 {
        justify-content: flex-start !important;
    }
}

@media (max-width: 575px) {
    .bulk-personalization-split .white_box {
        padding: 12px !important;
    }

    .bulk-split-table-section {
        max-height: 55vh;
    }

    .bulk-split-table {
        min-width: 560px;
    }

    .bulk-split-table thead th.address-col,
    .address-cell {
        min-width: 165px;
    }

    .address-cell .address-line {
        line-height: 16px;
    }

    .address-cell .address-line .address-recipient-name,
    .address-cell .default-address-badge {
        font-size: 11px;
    }
}
</style>
